module.exports = __webpack_public_path__ + "img/more.2aae326f.svg";